module.exports = __webpack_public_path__ + "img/T6-C-rc_0.6a14c9f8.png";